import { apiService } from './apiService';
import { getApiErrorMessage } from './tenantDefaultsService';

const CONNECTION = 'backend_py';
const BASE_PATH = '/api/v1/tenant-defaults/base-urls';

export interface TenantBaseUrlsDto {
  omniChatAssistantUrl: string;
  llmGatewayUrl: string;
}

function asDto(raw: unknown): TenantBaseUrlsDto {
  const row = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  return {
    omniChatAssistantUrl: String(row.omniChatAssistantUrl ?? row.omni_chat_assistant_url ?? '').trim(),
    llmGatewayUrl: String(row.llmGatewayUrl ?? row.llm_gateway_url ?? '').trim(),
  };
}

export const baseUrlsService = {
  async get(): Promise<TenantBaseUrlsDto> {
    return asDto(await apiService.get(BASE_PATH, {}, CONNECTION));
  },

  async upsert(omniChatAssistantUrl: string, llmGatewayUrl: string): Promise<TenantBaseUrlsDto> {
    return asDto(
      await apiService.put(
        BASE_PATH,
        {
          omniChatAssistantUrl: omniChatAssistantUrl.trim(),
          llmGatewayUrl: llmGatewayUrl.trim(),
        },
        CONNECTION
      )
    );
  },
};

export { getApiErrorMessage };
